import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import * as utils from './utils';
import { useTranslation } from 'react-i18next';

const currencyWarning: EngineRenderers['CheckoutCurrencyWarning'] = ({ total }) => {
	const { t } = useTranslation('Checkout');

	const showNote = utils.needShowWarning(total);

	return (
		showNote && (
			<div>
				{t(
					'All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.'
				)}
			</div>
		)
	);
};

export default currencyWarning;
